import * as React from "react";

function SvgForklift(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill } = props;
  return (
    <svg width={13} height={13} viewBox="0 0 13 13" fill="none" {...props}>
      <g clipPath="url(#clip0)">
        <path
          d="M1.02917 3.32709C1.02917 3.19167 1.08334 3.08334 1.16459 3.00209C1.24584 2.89375 1.38125 2.86667 1.48959 2.86667H4.49584C4.65834 2.86667 4.82084 2.975 4.90209 3.11042L6.68959 6.60417H7.28542L5.38959 2.86667C5.22709 2.51459 4.875 2.325 4.49584 2.325H1.48959C1.21875 2.325 0.975003 2.43334 0.78542 2.62292C0.595836 2.8125 0.487503 3.05625 0.487503 3.32709V7.2H1.02917V3.32709Z"
          fill={fill ?? "black"}
        />
        <path
          d="M8.775 2H8.09792C8.09792 4.00417 8.09792 6.30625 8.09792 7.14583C7.66458 7.14583 7.09583 7.14583 6.60833 7.14583C6.58125 7.17292 5.525 9.23125 5.57917 9.09583C5.49792 9.23125 5.38958 9.3125 5.22708 9.3125H4.49583C4.27917 9.3125 4.11667 9.12292 4.11667 8.93333V7.71458H1.02917H0.4875H0V10.6667C0 10.8292 0.08125 10.9917 0.216667 11.0729C0.216667 10.9917 0.189583 10.9375 0.189583 10.8563C0.189583 9.98958 0.89375 9.28542 1.7875 9.28542C2.65417 9.28542 3.35833 9.98958 3.35833 10.8563C3.35833 10.9646 3.35833 11.0729 3.33125 11.1812H5.95833C5.90417 11.0187 5.87708 10.8563 5.87708 10.6667C5.87708 9.71875 6.63542 8.93333 7.58333 8.90625C7.85417 8.85208 8.50417 9.04167 8.88333 9.44792H13V8.71667H8.775V2Z"
          fill={fill ?? "black"}
        />
        <path
          d="M7.6375 9.47501C6.96041 9.47501 6.41875 10.0167 6.41875 10.6938C6.41875 11.3708 6.9875 11.9125 7.6375 11.9125C8.31458 11.9125 8.85625 11.3708 8.85625 10.6938C8.85625 9.98959 8.2875 9.47501 7.6375 9.47501Z"
          fill={fill ?? "black"}
        />
        <path
          d="M1.76042 9.82709C1.19167 9.82709 0.70417 10.2875 0.70417 10.8563C0.70417 11.425 1.16459 11.9125 1.76042 11.9125C2.35625 11.9125 2.78959 11.425 2.78959 10.8563C2.81667 10.2875 2.35625 9.82709 1.76042 9.82709Z"
          fill={fill ?? "black"}
        />
        <path d="M13 5.7375H9.28959V8.175H13V5.7375Z" fill={fill ?? "black"} />
        <path d="M13 2.51459H9.28959V4.95209H13V2.51459Z" fill={fill ?? "black"} />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width={13} height={13} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgForklift;
